export const DEFAULT_HUB_PRIMARY_COLOR = '#1A4A35';
